/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.

  Modified by yang@onerockwell

==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') {
    ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
  Yang@onerockwell Added ShopifyAPI.addMultipleItems
==============================================================================*/
ShopifyAPI.addMultipleItems = function(data, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart');
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item);
                } else {
                    ShopifyAPI.onItemAdded(line_item);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

function messageGiftCard(message) {
    let element = document.createElement('div');
    element.className = 'popup-message-gift-card';
    element.innerText = message;

    document.body.appendChild(element);

    setTimeout(() => {
        element.classList.add('show');
    }, 50);

    setTimeout(() => {
        element.classList.remove('show');
        setTimeout(() => element.remove(), 300);
    }, 3000);
}

ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {

    const GIFT_CARD_PRODUCT_ID = "";
    let giftCardsId = GIFT_CARD_PRODUCT_ID.toString().split(',').map(item => {
    const trimmed = item.trim();
    const num = Number(trimmed);
    console.log(`Parsed ID: "${trimmed}" ->`, num);
    return num;
    });

    const GIFT_CARD_PRODUCTS_ENABLE = false;
    const ERROR_ADD_GIFT = "";
    const ERROR_ADD_PRODUCT = "";

    const productId = Number($(form).data('product-id'));

    console.log('GIFT_CARD_PRODUCT_ID raw:', GIFT_CARD_PRODUCT_ID);
    console.log('giftCardsId parsed:', giftCardsId);
    console.log('productId from form:', productId);
    console.log('isAddingGiftCard:', giftCardsId.includes(productId));
    console.log('form element:', form);
    console.log('form data attributes:', $(form).data());
    console.log('productId:', productId);

    let isAddingGiftCard = giftCardsId.includes(productId);

    ShopifyAPI.getCart(function(cart) {

        let hasGiftCard = false;
        let hasOtherProducts = false;

       cart.items.forEach(item => {
        const isGift = giftCardsId.includes(Number(item.product_id));

        if (isGift) hasGiftCard = true;
        if (!isGift) hasOtherProducts = true;
    });

        if (GIFT_CARD_PRODUCTS_ENABLE) {
            if (hasOtherProducts && isAddingGiftCard) {
                messageGiftCard(ERROR_ADD_GIFT);
                return;
            }
            if (hasGiftCard && !isAddingGiftCard) {
                messageGiftCard(ERROR_ADD_PRODUCT);
                return;
            }
        }

    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);
                } else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);

                // dataLayer event for GTM
                window.dataLayer?.push({
                    'event': 'AddToCart',
                    'products': [{
                        'id': line_item.id,
                        'product_id': line_item.product_id,
                        'name': line_item.product_title,
                        'price': line_item.price / 100,
                        'category': line_item.product_type,
                        'brand': 'MoviesEc',
                        'variant': line_item.title,
                        'quantity': line_item.quantity,
                        'discount': line_item.line_price - line_item.original_line_price
                    }]
                })
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
});
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function(cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback, errorCallback) {

    const updatedProductData = JSON.parse( $(`.ajaxcart__row[data-line="${line}"] .ajaxcart__json-info`).text() );

    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function(cart) {

                if ((typeof callback) === 'function') {
                    callback(cart, updatedProductData, quantity);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);

                if(quantity == 0){
                    //console.log('product was removed from cart');
                    //alert('Product was removed from cart');
                    // window.dataLayer.push({
                    //     'event': 'RemoveFromCart',
                    //     'products': [updatedProductData]
                    // })
                }
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus, line);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};



/*============================================================================
  Product Options
==============================================================================*/
ShopifyAPI.selectCallback = function(variant, selector) {
    // var moneyFormat = Shopify.money_format;
    var moneyFormat = theme.moneyFormat;
    var disabledCTAClass = 'disabled';
    const inventoryDisplayThreshold = 10;

    // Selectors
    if (selector.domIdPrefix.split('-').length > 1) {
        var selectorArray = selector.domIdPrefix.split('-');
        var $addToCart = $('[id^="AddToCart-' + selectorArray[1] +'"]');
    } else {
        var $addToCart = $('#AddToCart');
    }

    // Find the product wrapper - could be .product-core or .quick-buy-container
    var $productWrapper = $addToCart.parents('.product-core').length ? $addToCart.parents('.product-core') : $addToCart.parents('.quick-buy-container'),
        $productPrice = $productWrapper.find('.product-price'),
        $comparePrice = $productWrapper.find('.product-compare-price'),
        $addToCartText = $productWrapper.find('.add-to-cart-text'),
        $form = $addToCart.closest('form'),
        $outOfStockBadge = $form.find('.variant-out-of-stock-badge');

    // Variant
    if (variant) {
        // Select a valid variant if available
        if (variant.available) {
            // Available, enable the submit button, change text, show quantity elements
            $addToCart.removeClass('disabled sold-out').prop('disabled', false);
            // Remove tooltip when variant has stock
            $addToCart.removeAttr('title');
            if ($addToCart.hasClass('pre-order')) {
                $addToCartText.html("Pre Order");
            } else {
                $addToCartText.html("Agregar a mi bolsa");
            }
            // Hide out of stock badge
            if ($outOfStockBadge.length) {
                $outOfStockBadge.removeClass('show').css('display', 'none').hide();
            }
        } else {
            // Sold out, disable the submit button, change text, hide quantity elements
            $addToCart.addClass(`${disabledCTAClass} sold-out`).prop('disabled', true);
            if (!$addToCart.hasClass('inquire')) {
                // $addToCartText.html("Agregar a mi bolsa");
                $addToCartText.html("No disponible");
            }
            // Add tooltip to button
            $addToCart.attr('title', 'No hay más unidades disponibles');
            // Show out of stock badge
            if ($outOfStockBadge.length) {
                // Re-trigger animation each time a sold-out variant is selected
                $outOfStockBadge.removeClass('show');
                // Force reflow to ensure animation restarts
                void $outOfStockBadge[0].offsetWidth;
                $outOfStockBadge.css('display', 'block').show().addClass('show');
            }
        }
        // console.log('variant selected and update price', variant);
        if(typeof variantStock !== 'undefined'){
            let selectedVariantInventoryInfo = variantStock.filter( (item)=> item.variant == variant.id );
            let selectedVariantInventory = selectedVariantInventoryInfo[0].inventory;
            let unitsWording = selectedVariantInventory == 1 ? 'unit' : 'units';
            if(selectedVariantInventory > 0 && selectedVariantInventory <= inventoryDisplayThreshold){
                $productWrapper.find('.variant-selection-availability').addClass('active').find('.qty').text(selectedVariantInventory);
                $productWrapper.find('.variant-selection-availability').find('units').text(unitsWording);
            }else{
                $productWrapper.find('.variant-selection-availability').removeClass('active').find('.qty').empty;
            }
        }
        // Show available units info


        // Regardless of stock, update the product price
        var increasedPrice = ((variant.price * 1.15) / 100).toFixed(2);
        var increasedCompareAtPrice = ((variant.compare_at_price * 1.15) / 100).toFixed(2);
        $productPrice.html(Shopify.formatMoney(increasedPrice, moneyFormat));

        // Also update and show the product's compare price if necessary
        if (increasedCompareAtPrice > increasedPrice) {
            $comparePrice.html(Shopify.formatMoney(increasedCompareAtPrice, moneyFormat)).show();
        } else {
            $comparePrice.hide();
        }

    } else {
        $addToCart.addClass(disabledCTAClass);
        $addToCart.addClass('disabled');//.prop('disabled', true);
        // Remove tooltip when no variant is selected
        $addToCart.removeAttr('title');
        if (!$addToCart.hasClass('inquire') && !$addToCart.hasClass('sold-out')) {
            //$addToCartText.html("No disponible");
            //$addToCartText.html("Select a ");
        }
        // Hide out of stock badge when no variant is selected
        if ($outOfStockBadge.length) {
            $outOfStockBadge.removeClass('show').css('display', 'none').hide();
        }
    }

    $addToCart.removeClass('loading');
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback,  buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function(options) {

        // Default settings
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: null,
            cartCostSelector: null,
            moneyFormat: '$',
            disableAjaxCart: false,
            enableQtySelectors: true
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $formContainer = $(settings.formSelector);
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector = $(settings.cartCostSelector);

        // General Selectors
        $body = $(document.body);

        // Track cart activity status
        isUpdating = false;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
            // console.log('enableQtySelectors??',settings.enableQtySelectors);
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function() {
        $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function(cart) {
        if ($cartCountSelector) {
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
            $('#MiniCart').find('.item-count').text(cart.item_count).addClass('updated');

            if (cart.item_count === 0) {
                $cartCountSelector.addClass('hidden-count');
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }
    };

    formOverride = function() {
        $formContainer.off('submit').on('submit', function(evt) {
            evt.preventDefault();
            var proceed = true;
            var $currForm = $(evt.target);
            var $selects = $currForm.find('select');
            $.each($selects, function(i, v) {
                if ($(v).val() == '') {
                    proceed = false;
                    return false;
                }
            });

            if (!proceed) {
                alert('Please select all options');
                return false;
            }

            // Get the add to cart button for this specific form
            var $currentAddToCartBtn = $currForm.find('button[type="submit"][name="add"]');
            
            // Add class to be styled if desired
            $currentAddToCartBtn.removeClass('is-added').addClass('is-adding');

            // Remove any previous quantity errors
            $(document).find('.qty-error').remove();

            // Create error callback with form context
            var errorCallback = function(res, text) {
                itemErrorCallback(res, text, $currForm);
            };

            ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, errorCallback);
        });
    };

    itemAddedCallback = function(line_item) {
        $addToCart.removeClass('is-adding').addClass('is-added');

        ShopifyAPI.getCart(function(cart) {
            cartUpdateCallback( cart );
            const itemAddedEvent = new Event('afterAddToCart.ajaxCart', cart);
            document.body.dispatchEvent(itemAddedEvent);
        });
    };

    itemErrorCallback = function(res, text, $form) {
        // Get the form from parameter or try to find it
        if (!$form) {
            $form = $addToCart.closest('form');
        }
        
        var $currentAddToCartBtn = $form.find('button[type="submit"][name="add"]');
        $currentAddToCartBtn.removeClass('is-adding is-added');

        if (!!text) {
            if (res.status == 422) {
                // Remove any previous error messages
                $(document).find('.qty-error').remove();
                
                // Find the badge for this specific product
                var $currentBadge = $form.find('.variant-out-of-stock-badge');
                
                // Show badge and disable button instead of showing error message
                if ($currentBadge.length) {
                    $currentBadge.css('display', 'block').show();
                }
                if ($currentAddToCartBtn.length) {
                    $currentAddToCartBtn.addClass('disabled sold-out').prop('disabled', true);
                    // Add tooltip to button
                    $currentAddToCartBtn.attr('title', 'No hay más unidades disponibles');
                    var $addToCartText = $currentAddToCartBtn.find('.add-to-cart-text');
                    if ($addToCartText.length) {
                        $addToCartText.html("No disponible");
                    }
                }
            }
        }
    };

    cartUpdateCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);
    };

    buildCart = function(cart) {
        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            $cartContainer
                $cartContainer.append(`<div class="container-cart-empty">
                <div class="cart-empty-container">
                    <div class="ajaxcart__empty"> <p><em>Tu carrito está vacío</em><strong> 🙈</strong></p> </div>
                    <div class="container-images-cart-empty">
                        <div 
                            class="cart-empty-images-grid"
                            style="
                                grid-template-columns: repeat(2, 1fr);"
                        >
                            
                                <a href="https://moviesshop.ec/collections/mujer">
                                    <img src="//www.moviesshop.ec/cdn/shop/files/98d71fe2-0747-4b50-b884-bebadbf853ad___234e8c7fdcdda680583723d7bc7735aa_1_2_6f919383-ddfc-468b-b257-333643e0c157.png?v=1787221426" class="cart-empty-img">
                                </a>
                            
                            
                                <a href="https://moviesshop.ec/collections/hombre">
                                    <img src="//www.moviesshop.ec/cdn/shop/files/db9e59ca-0c41-4179-8d32-beb487ce5a6b___5b51f458ddb79e71dddf02375d1cb11a_1_2_5e9676cc-665b-41ed-9c6c-33de6dbf69fc.webp?v=1787221426" class="cart-empty-img">
                                </a>
                            
                        </div>
                    </div>
                    <div class="ajaxcart__empty"> <p>Explora nuestras categorías 🤖</p> </div>
                    <section class="container-cart-empty-categories">
                        
                        
                        
                            
                            
                            
                            
                            

                            

                            
                                
                                    <a href="/collections/mujer-camisetas" class="cart-empty-category-item ">
                                        Camisetas para Mujer
                                    </a>
                                
                            
                        
                            
                            
                            
                            
                            

                            

                            
                                
                                    <a href="/collections/hombre-camisetas" class="cart-empty-category-item ">
                                        Camisetas para Hombre
                                    </a>
                                
                            
                        
                            
                            
                            
                            
                            

                            

                            
                                
                                    <a href="/collections/mujer-pijamas" class="cart-empty-category-item ">
                                        Pijamas para Mujer
                                    </a>
                                
                            
                        
                            
                            
                            
                            
                            

                            

                            
                                
                                    <a href="/collections/pijamas-hombre" class="cart-empty-category-item ">
                                        Pijamas para Hombre
                                    </a>
                                
                            
                        
                            
                            
                            
                            
                            

                            

                            
                                
                                    <a href="/collections/descuentos-de-temporada" class="cart-empty-category-item is-offer">
                                        Ofertas de temporada 🔥
                                    </a>
                                
                            
                        
                            
                            
                            
                            
                            

                            

                            
                                
                                    
                                    <a href="/pages/licencias-y-personajes" class="cart-empty-category-item ">
                                        Licencias & Personajes
                                    </a>
                                
                            
                        
                            
                            
                            
                            
                            

                            

                            
                                
                                    <a href="/collections/mujer-buzos-y-chaquetas" class="cart-empty-category-item ">
                                        Buzos y Chaquetas para Mujer
                                    </a>
                                
                            
                        
                            
                            
                            
                            
                            

                            

                            
                                
                                    <a href="/collections/hombre-buzos-y-chaquetas" class="cart-empty-category-item ">
                                        Buzos y Chaquetas para Hombre
                                    </a>
                                
                            
                        
                    </section>
                </div>
            </div>`);
            cartCallback(cart);
            return;
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);

            let currencyPrefix = 'USD';
            let currencyPrefixPosition = 'before';

        // Add each item to our handlebars.js data
        $.each(cart.items, function(index, cartItem) {
            /* Hack to get product image thumbnail
             *   - If image is not null
             *     - Remove file extension, add _small, and re-add extension
             *     - Create server relative link
             *   - A hard-coded url of no-image
             */
            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            var discountAmount = 0;

            if (cartItem.original_price > cartItem.final_price) {
                discountAmount = Math.round(((cartItem.original_price - cartItem.final_price) / cartItem.original_price) * 100
                );
            }

            // Create item's data object and add to 'items' array
            item = {
                key: cartItem.key,
                id: cartItem.id,
                product_id: cartItem.product_id,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title.replace('MoviesEc ',''),
                variation: cartItem.options_with_values && cartItem.options_with_values[2] ? cartItem.options_with_values[2].value : cartItem.variant_title,
                variant_name: cartItem.title,
                properties: cartItem.properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price_noformat: cartItem.price / 100,
                price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
                vendor: cartItem.vendor,
                product_type: cartItem.product_type,
                linePrice: currencyPrefixPosition === 'before'
                ? currencyPrefix + ' ' + (cartItem.line_price / 100).toFixed(2)
                : (cartItem.line_price / 100).toFixed(2) + ' ' + currencyPrefix,
                originalLinePrice: currencyPrefixPosition === 'before'
                ? currencyPrefix + ' ' + (cartItem.original_line_price / 100).toFixed(2)
                : (cartItem.original_line_price / 100).toFixed(2) + ' ' + currencyPrefix,
                discounts: (cartItem.discounts || []).map(function(d) {
                return {
                    title: d.title,
                    amount: currencyPrefixPosition === 'before'
                    ? currencyPrefix + ' ' + (d.amount / 100).toFixed(2)
                    : (d.amount / 100).toFixed(2) + ' ' + currencyPrefix
                };
                }),
                discount_count: (cartItem.discounts || []).length,
                discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
                discount_amount: discountAmount,
                isGiftCard: cartItem.gift_card,
                variationLabel: cartItem.gift_card ? 'Valor' : 'Talla',
            };

            items.push(item);
        });

        let currentDate = 1793356694;
        let freeShippingBar = false;
        let freeShippingMinimum = 65;
        let freeShippingLabelEnable = false;
        let freeShippingLabel = true;
        let freeShippingLabelMessage = "🔥 ENVÍO GRATIS SOLO POR HOY 🔥";
        let freeShippingCurrentDay = new Date(currentDate * 1000);
        let freeShippingActiveFrom = "2026-08-04 00:00";
        let freeShippingPastDay = new Date(freeShippingActiveFrom.replace(' ', 'T'));
        let freeShippingActiveTo = "2026-08-05 00:00";
        let freeShippingFutureDay = new Date(freeShippingActiveTo.replace(' ', 'T'));

        let freeShippingMessage = '';
        let freeShippingRemainingValue = '';
        let freeShippingRemainingPercentage = '';
        let freeShippingCompleted = false;

        if (freeShippingMinimum != '') {
            freeShippingBar = true;
            freeShippingRemainingValue = (freeShippingMinimum - (cart.total_price / 100)).toFixed(2);
            freeShippingRemainingPercentage = ( ( cart.total_price / 100) / freeShippingMinimum ) * 100;

            freeShippingRemainingPercentage = freeShippingRemainingPercentage > 100 ? 100 : freeShippingRemainingPercentage;

            if(freeShippingRemainingValue < 1){
                freeShippingMessage = '<svg xmlns="http://www.w3.org/2000/svg" fill="#00b37e" width="18px" viewBox="0 -960 960 960" height="18px"><path d="M155-227q-35-35-35-85H48v-408q0-29.7 21.15-50.85Q90.3-792 120-792h552v144h120l120 168v168h-72q0 50-35 85t-85 35q-50 0-85-35t-35-85H360q0 50-35 85t-85 35q-50 0-85-35Zm119-51q14-14 14-34t-14-34q-14-14-34-14t-34 14q-14 14-14 34t14 34q14 14 34 14t34-14ZM120-384h24q17-23 42-35.5t54-12.5q29 0 54 12.5t41.53 35.5H600v-336H120v336Zm634 106q14-14 14-34t-14-34q-14-14-34-14t-34 14q-14 14-14 34t14 34q14 14 34 14t34-14Zm-82-178 168-1-85-119h-83v120Zm-310-93Z"/></svg> ¡Tu envío es totalmente gratis!'
                freeShippingCompleted = true;
            } else {
                    let formattedRemaining;
            if (currencyPrefixPosition === 'before') {
                        formattedRemaining = '<strong style="font-weight:600;">' + currencyPrefix + ' ' + freeShippingRemainingValue + '</strong>';
                } else {
                    formattedRemaining = '<strong style="font-weight:600;">' + freeShippingRemainingValue + ' ' + currencyPrefix + '</strong>';
                }
                freeShippingMessage = 'Faltan [value] para que tu envío sea gratis!';
                freeShippingMessage = freeShippingMessage.replace('[value]', formattedRemaining);
                freeShippingCompleted = false;
            }

        if(freeShippingLabel) {
            freeShippingLabelEnable = true;
            if(freeShippingCurrentDay < freeShippingPastDay) {
                freeShippingLabelEnable = false;
            } else if(freeShippingCurrentDay > freeShippingFutureDay) {
                freeShippingLabelEnable = false;
            }
        } else {
            freeShippingLabelEnable = false;
        }

    }

        // Gather all cart data and add to DOM
        data = {
            items: items,
            note: cart.note,
            totalItems: items.length,
            totalPrice: currencyPrefixPosition === 'before' 
            ? currencyPrefix + ' ' + (cart.total_price / 100).toFixed(2)
            : (cart.total_price / 100).toFixed(2) + ' ' + currencyPrefix,
            totalCartDiscount: cart.total_discount === 0 ? 0 : "\u003cp\u003eAhorras\u003c\/p\u003e".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
            totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
            totalCartDiscountAmount: currencyPrefixPosition === 'before'
            ? currencyPrefix + ' ' + (cart.total_discount / 100).toFixed(2)
            : (cart.total_discount / 100).toFixed(2) + ' ' + currencyPrefix,
            freeShippingBar: freeShippingBar,
            freeShippingLabelEnable: freeShippingLabelEnable,
            freeShippingLabelMessage: freeShippingLabelMessage,
            freeShippingMessage: freeShippingMessage,
            freeShippingMinimum: freeShippingMinimum,
            freeShippingRemainingValue: freeShippingRemainingValue,
            freeShippingRemainingPercentage: freeShippingRemainingPercentage,
            freeShippingCompleted: freeShippingCompleted
        }

        $cartContainer.append(template(data));

        cartCallback(cart);
    };

    cartCallback = function(cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }
    };

    adjustCart = function() {
        // Delegate all events because elements reload with the cart

        // Add or remove from the quantity
        $(document).on('click', '.ajaxcart__qty-adjust', function(evt) {
            evt.preventDefault();
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        $(document).on('click', '.ajaxcart__qty-remove', function(e) {
            e.preventDefault();
            var $el = $(this),
                line = $el.data('line');

            if (isUpdating) {
                return;
            }
            updateQuantity(line, 0);
        });

        // Update quantity based on input on change
        $(document).on('change', '.ajaxcart__qty-num', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $(document).on('focus', '.ajaxcart__qty-adjust', function(evt) {
            var $el = $(this);
            setTimeout(function() {
                $el.select();
            }, 50);
        });

        function updateQuantity(line, qty) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }

            // Error callback for when trying to add more than available
            var errorCallback = function(res, text, line) {
                isUpdating = false;
                $row.removeClass('is-loading');
                
                if (res.status == 422) {
                    // Find the badge for this specific line item
                    var $badge = $('.ajaxcart__out-of-stock-badge[data-line="' + line + '"]');
                    
                    if ($badge.length) {
                        // Remove and re-add class to trigger animation
                        $badge.removeClass('show');
                        // Force reflow to ensure animation restarts
                        void $badge[0].offsetWidth;
                        // Show badge with animation
                        $badge.css('display', 'block').show().addClass('show');
                        
                        // Hide badge after 2.5 seconds
                        setTimeout(function() {
                            $badge.removeClass('show').fadeOut(300, function() {
                                $badge.css('display', 'none');
                            });
                        }, 2500);
                    }
                    
                    // Revert quantity to previous value by getting current cart
                    ShopifyAPI.getCart(function(cart) {
                        var currentItem = cart.items[line - 1]; // line is 1-indexed
                        if (currentItem) {
                            var $qtyInput = $row.find('.ajaxcart__qty-num');
                            $qtyInput.val(currentItem.quantity);
                        }
                    });
                }
            };

            // Slight delay to make sure removed animation is done
            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback, errorCallback);
            }, 250);
        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });
    };

    adjustCartCallback = function(cart, updatedProductData, quantity) {
        // Update quantity and price
        updateCountPrice( cart );

        const adjustCartEvent = new Event('adjustCartCallback.ajaxCart', cart);
        document.body.dispatchEvent(adjustCartEvent);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function() {
            isUpdating = false;
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };

    createQtySelectors = function() {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function() {
                var $el = $(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    qtySelectors = function() {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input.enable-qty-selector');

        if (numInputs.length) {
            numInputs.each(function() {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', function() {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));

                var qty = validateQty(qty);

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }

                // Update the input's number
                $qtySelector.val(qty);
            });
        }
    };

    validateQty = function(qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));